import { render } from "./NewsletterForm.vue?vue&type=template&id=19e48e14&scoped=true"
import script from "./NewsletterForm.vue?vue&type=script&lang=js"
export * from "./NewsletterForm.vue?vue&type=script&lang=js"

import "./NewsletterForm.vue?vue&type=style&index=0&id=19e48e14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e48e14"]])

export default __exports__